import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent implements AfterViewInit, OnDestroy {
  private destroy$ = new Subject();
  public sessionId?: string;

  @ViewChild('container', { static: false })
  container!: ElementRef<HTMLElement>;

  constructor(private snackBar: MatSnackBar) {}

  ngAfterViewInit(): void {
    timer(0, 2000)
      .pipe(takeWhile((value) => value < this.container.nativeElement.childElementCount))
      .subscribe((value) => this.updateAnimation(value));
  }

  public updateAnimation(value: number): void {
    if (value === 0) {
      return;
    }

    for (let i = 0; i < this.container.nativeElement.childElementCount; i++) {
      const child = this.container.nativeElement.children.item(i);

      if (!child) continue;

      if (i === value) {
        child.classList.remove('hidden');
        child.classList.add('shown');
      } else {
        child.classList.remove('shown');
        child.classList.add('hidden');
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
